module.exports = __webpack_public_path__ + "static/bg1-218d69526a1c2eef74c87c95d467237b.jpg";